import {
  passwordlessLogin,
  passwordlessStart
} from "openstack-uicore-foundation/lib/security/methods";
import { createAction } from "openstack-uicore-foundation/lib/utils/actions";
import { getUserInfo } from "openstack-uicore-foundation/lib/security/actions";

export const SET_PASSWORDLESS_LOGIN = "SET_PASSWORDLESS_LOGIN";
export const SET_PASSWORDLESS_LENGTH = "SET_PASSWORDLESS_LENGTH";
export const SET_PASSWORDLESS_ERROR = "SET_PASSWORDLESS_ERROR";
export const RESET_OTP = "RESET_OTP";
export const SET_IDP_CONFIG = "SET_IDP_CONFIG";
export const SET_IDP_CONFIG_LOADING = "SET_IDP_CONFIG_LOADING";
export const SET_IDP_CONFIG_ERROR = "SET_IDP_CONFIG_ERROR";
const IDP_CONFIG_FETCH_TIMEOUT_MS = 8000;

export const fetchIdpConfig = () => async (dispatch) => {
  dispatch(createAction(SET_IDP_CONFIG_LOADING)());
  const controller = new AbortController();
  const timeoutId = setTimeout(
    () => controller.abort(),
    IDP_CONFIG_FETCH_TIMEOUT_MS
  );
  try {
    const url = `${window.IDP_BASE_URL}/.well-known/openid-configuration`;
    const response = await fetch(url, { signal: controller.signal });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const config = await response.json();
    dispatch(createAction(SET_IDP_CONFIG)(config));
  } catch (e) {
    console.error("Failed to fetch IDP config", e);
    dispatch(createAction(SET_IDP_CONFIG_ERROR)());
  } finally {
    clearTimeout(timeoutId);
  }
};

export const resetOtp = () => (dispatch) => {
  dispatch(createAction(RESET_OTP)({}));
};

const getPasswordlessCode = (email) => {
  const params = {
    connection: "email",
    send: "code",
    redirect_uri: `${window.location.origin}/auth/callback`,
    email
  };

  return passwordlessStart(params);
};

export const getLoginCode = (email) => async (dispatch) => {
  dispatch(createAction(SET_PASSWORDLESS_LOGIN)(email));
  return new Promise((resolve, reject) => {
    getPasswordlessCode(email).then(
      (res) => {
        dispatch(createAction(SET_PASSWORDLESS_LENGTH)(res.response));
        resolve(res);
      },
      (err) => {
        const errorMessage = err.response?.body?.error || err.message;
        reject(new Error(errorMessage));
      }
    );
  });
};

const loginWithCode = (code, email) => (dispatch) => {
  const params = {
    connection: "email",
    otp: code,
    email
  };

  return dispatch(passwordlessLogin(params))
    .then(() =>
      dispatch(getUserInfo()).then(() => {
        window.location.href = "/app";
      })
    )
    .catch((e) => {
      console.log(e);
      return Promise.reject(e);
    });
};

export const loginWithOtp = (code) => async (dispatch, getState) => {
  const {
    loginState: {
      passwordless: { email }
    }
  } = getState();

  return loginWithCode(
    code,
    email
  )(dispatch)
    .then((res) => res)
    .catch((e) => {
      console.log(e);
      dispatch(createAction(SET_PASSWORDLESS_ERROR)());
    });
};
